<template>
  <div>
    <CatalogList
      v-if="hasCatalogList"
      :id="id"
      :key="`${recommendSeriesId}__${recommendContentId}`"
      :catalog-list="catalogList"
    />
    <MyPooqEmptyList
      v-if="!hasCatalogList && !isLoading"
      info-text="추천 콘텐츠가 없어요."
    />
  </div>
</template>
<script setup>
  import { ref, computed, defineProps } from 'vue'
  import { getRecommendHomeData } from '@/common/requests/data-fetch/get-recommend-home-data'
  import { useLoadingProgress } from '@/common/use/useLoadingProgress'
  import CatalogList from '@/components/catalog/CatalogList.vue'
  import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList.vue'

  const { showLoadingProgress, hideLoadingProgress } = useLoadingProgress()

  const catalogData = ref(null)
  const id = ref('')

  const props = defineProps({
    section: {
      type: String, // 'movie' | 'vod'
      default: '',
    },
    contentInfo: {
      type: Object,
      default: () => {},
    },
  })

  const isLoading = ref(false)
  const isVod = computed(() => props.section === 'vod')
  const homeCode = computed(() => (isVod.value ? 'DN1' : 'DN2'))
  const programId = computed(() => props.contentInfo?.programid ?? '')
  const contentId = computed(() => props.contentInfo?.contentid ?? '')
  const movieId = computed(() => props.contentInfo?.movieid ?? '')
  const movieGroupId = computed(() => props.contentInfo?.moviegroupid ?? '')

  const recommendSeriesId = computed(() =>
    isVod.value ? programId.value : movieGroupId.value,
  )
  const recommendContentId = computed(() =>
    isVod.value ? contentId.value : movieId.value,
  )
  const catalogList = computed(() => catalogData.value?.catalogList)
  const hasCatalogList = computed(
    () => catalogList.value && catalogList.value?.length > 0,
  )

  const init = async () => {
    isLoading.value = true
    showLoadingProgress()
    const { data } = await getRecommendHomeData({
      homeCode: homeCode.value,
      seriesId: recommendSeriesId.value,
      contentId: recommendContentId.value,
    })

    const { catalog } = data?.layout
    catalogData.value = catalog ?? {}
    hideLoadingProgress()
    isLoading.value = false
  }

  init()
</script>
